import type { AdminApiUser } from '@/types/serializers';
import { useQuery } from '@tanstack/react-query';

type AdminUsersResponse =
  | AdminApiUser[]
  | {
      data?: AdminApiUser[];
    };

const normalizeUsers = (payload: AdminUsersResponse): AdminApiUser[] => {
  if (Array.isArray(payload)) {
    return payload;
  }
  return payload.data ?? [];
};

export default function useFetchAdminUsers() {
  return useQuery({
    queryKey: ['admin', 'users'],
    queryFn: async () => {
      const response = await fetch('/admin/api/users');
      if (!response.ok) {
        throw new Error('ユーザー一覧の取得に失敗しました');
      }
      const data: AdminUsersResponse = await response.json();
      return normalizeUsers(data);
    },
  });
}
